import React from "react";
import RadioBlock from "../radio-block/RadioBlock";
import webpay from "../../../../assets/images/logo-webpay-plus-blanik-660x312.png";
import PropTypes from 'prop-types';

export const WebPay = (props) => {
  const {paymentType, ...other} = props;

  return (
    <RadioBlock
      {...other}
      checked={paymentType === "WebPay"}
      className="my-2"
      name="online-payment"
      id="radio-webpay"
      value="WebPay"
      label={<span><b>Pago en línea</b> con tu tarjeta de débito o crédito en WebPay</span>}
      end={<div className="flex-center"><img src={webpay} alt=""/></div>}
    />
  );
};

WebPay.propTypes = {
  paymentType: PropTypes.string
}

WebPay.defaultProps = {
  paymentType: ""
}

export default WebPay;
